import { render, staticRenderFns } from "./AbmTable.vue?vue&type=template&id=3ae680b8&"
import script from "./AbmTable.vue?vue&type=script&lang=js&"
export * from "./AbmTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports